Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_jsxFileName='es6/PageStateProvider.js';var _react=require('react');var _react2=_interopRequireDefault(_react);
var _propTypes=require('prop-types');var _propTypes2=_interopRequireDefault(_propTypes);

var _get=require('lodash/get');var _get2=_interopRequireDefault(_get);
var _flat=require('flat');var _flat2=_interopRequireDefault(_flat);

var _Handler=require('./Handler');var _Handler2=_interopRequireDefault(_Handler);

var _PageStateContext=require('./PageStateContext');function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

PageStateProvider=(_temp=_class=function(_Component){_inherits(PageStateProvider,_Component);













function PageStateProvider(props){_classCallCheck(this,PageStateProvider);var _this=_possibleConstructorReturn(this,(PageStateProvider.__proto__||Object.getPrototypeOf(PageStateProvider)).call(this,
props));_this.state={isRenderChildren:!_this.props.callback};_this.















setPageState=function(path,value){
if(!_this.mount)return;
_this.setState(_defineProperty({},
path,value));

};_this.

resetPageState=function(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}
if(args&&args.length){
_this.setPageState(args[0]);
}else{
_this.reset();
}
};_this.

reset=function(){
var config=_this.getConfig();
Object.keys(config).forEach(function(key){return _this.setPageState(key);});
};_this.

getConfig=function(){var
config=_this.props.config;
var flattenConfig=(0,_flat2.default)(config);
return flattenConfig;
};_this.mount=true;return _this;}_createClass(PageStateProvider,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.props.callback&&this.props.callback(this.getContext()).then(function(){_this2.setState({isRenderChildren:true});});}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.mount=false;}},{key:'getContext',value:function getContext()

{
return{
setPageState:this.setPageState,
resetPageState:this.resetPageState,
reset:this.reset};

}},{key:'render',value:function render()

{var _this3=this;
var config=this.getConfig();
return(
_react2.default.createElement(_PageStateContext.Provider,{value:this.getContext(),__source:{fileName:_jsxFileName,lineNumber:79}},
_react2.default.createElement(_react2.default.Fragment,{__source:{fileName:_jsxFileName,lineNumber:80}},
this.state.isRenderChildren&&this.props.children,
Object.keys(config).map(function(configName){
if((0,_get2.default)(_this3.state,configName)){
return _react2.default.createElement(_Handler2.default,_extends({key:'handler-'+configName,component:(0,_get2.default)(config,configName)},(0,_get2.default)(_this3.state,configName),{__source:{fileName:_jsxFileName,lineNumber:84}}));
}
return null;
}))));



}}]);return PageStateProvider;}(_react.Component),_class.propTypes={config:_propTypes2.default.shape().isRequired,callback:_propTypes2.default.func},_class.defaultProps={config:{}},_temp);exports.default=PageStateProvider;